import { render, staticRenderFns } from "./EditarVehiculosBase.vue?vue&type=template&id=61c2b547&"
import script from "./EditarVehiculosBase.vue?vue&type=script&lang=ts&"
export * from "./EditarVehiculosBase.vue?vue&type=script&lang=ts&"
import style0 from "./EditarVehiculosBase.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports